import http from "../http-common";
import { getStoredConsent } from "../context/CookieConsentContext";

/**
 * Sends a silent ping to the backend to track a unique profile view.
 * No-ops unless the user has opted into analytics cookies.
 * * @param {string} targetId - The MongoDB _id of the EPK, Actor, or Filmmaker.
 * @param {string} targetType - The type of profile being viewed ('EPK', 'ACTOR', 'FILMMAKER').
 */
const trackView = (targetId, targetType) => {
  if (!getStoredConsent()?.analytics) {
    return Promise.resolve();
  }

  return http.post("/analytics/track-view", {
    targetId,
    targetType
  }, {
    withCredentials: true // Allows the tracking cookies to be sent and received
  });
};

const getEpkAnalytics = (epkId, token) =>
  http.get(`/analytics/epk/${epkId}`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });

const AnalyticsDataService = {
  trackView,
  getEpkAnalytics,
};

export default AnalyticsDataService;